import Eraser from "@/icons/penTool/Eraser.svg?react";
import Highlighter from "@/icons/penTool/Highlighter.svg?react";
import PenIcon from "@/icons/penTool/PenIcon.svg?react";
import type { LineWidthOption, PenMode } from "@/interface/SideBar/PenMenu/types";
import { PEN_TOOL_LINE_WIDTH, PEN_TOOL_MODES } from "@/tools/PenTool/constants";

export const MODES: PenMode[] = [
    { type: PEN_TOOL_MODES[0], icon: <PenIcon /> },
    { type: PEN_TOOL_MODES[1], icon: <Highlighter /> },
    { type: PEN_TOOL_MODES[2], icon: <Eraser /> },
];

export const LINE_WIDTHS: LineWidthOption[] = [
    { width: PEN_TOOL_LINE_WIDTH[0], styleHeight: 1 },
    { width: PEN_TOOL_LINE_WIDTH[1], styleHeight: 3 },
    { width: PEN_TOOL_LINE_WIDTH[2], styleHeight: 6 },
];
